import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NgSelectModule } from '@ng-select/ng-select';
import { LicenseComponent } from './pages/license/license.component';
import { AppRoutingModule } from './app-routing.module';
import { FreeLicenseComponent } from './pages/freelicense/free-license.component';
import { FreeBatchComponent } from './pages/freebatch/free-batch.component';
import { VOMComponent } from './pages/vom/vom.component';
import { GeneratefileComponent } from './pages/generatefile/generatefile.component';

@NgModule({
  declarations: [AppComponent, LicenseComponent,FreeLicenseComponent,FreeBatchComponent,VOMComponent,GeneratefileComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule.forRoot([]),
    NgxSpinnerModule,
    SweetAlert2Module.forRoot(),
    NgSelectModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
